<template>
    <div class="neighborhood" id="neighborhood">
        <template v-if="showNav">
            <info :backImage="images.firstImage" class="scrollFade"></info>
            <description
                :description-title="description.title"
                :description-body="description.body"></description>
            <div class="images-block" v-if="images.gallery.length">
                <div class="images-block__group scrollFade">
                    <div>
                        <span :style="{ backgroundImage: 'url('+ images.gallery[0].imagePath + ')'}"></span>
                        <span :style="{ backgroundImage: 'url('+ images.gallery[1].imagePath + ')'}"></span>
                    </div>
                    <div class="images-block__group__big">
                        <span :style="{ backgroundImage: 'url('+ images.gallery[2].imagePath + ')'}"></span>
                    </div>
                </div>
                <div class="images-block__one scrollFade">
                    <span :style="{ backgroundImage: 'url('+ images.gallery[3].imagePath + ')'}"></span>
                </div>
                <div class="images-block__group scrollFade">
                    <div>
                        <span :style="{ backgroundImage: 'url('+ images.gallery[4].imagePath + ')'}"></span>
                        <span :style="{ backgroundImage: 'url('+ images.gallery[5].imagePath + ')'}"></span>
                    </div>
                    <div class="images-block__group__big">
                        <span :style="{ backgroundImage: 'url('+ images.gallery[6].imagePath + ')'}"></span>
                    </div>
                </div>
                <div class="images-block__one scrollFade">
                    <span :style="{ backgroundImage: 'url('+ images.gallery[7].imagePath + ')'}"></span>
                </div>
                <div class="images-block__group scrollFade">
                    <div>
                        <span :style="{ backgroundImage: 'url('+ images.gallery[8].imagePath + ')'}"></span>
                        <span :style="{ backgroundImage: 'url('+ images.gallery[9].imagePath + ')'}"></span>
                    </div>
                    <div class="images-block__group__big">
                        <span :style="{ backgroundImage: 'url('+ images.gallery[10].imagePath + ')'}"></span>
                    </div>
                </div>
                <div class="images-block__one scrollFade">
                    <span :style="{ backgroundImage: 'url('+ images.gallery[11].imagePath + ')'}"></span>
                </div>
            </div>
            <app-map v-if="showMap"></app-map>
            <app-footer></app-footer>
        </template>
    </div>
</template>

<script>
  import Description from "../components/Description";
  import Info from "../components/Info";
  import Map from "../components/Map";
  import Footer from "../layout/Footer";

    export default {
      name: "Neighborhood",
      components: {
        Description,
        Info,
        'app-map': Map,
        'app-footer': Footer
      },
      data: () => ({
        images: {
          firstImage: '',
          gallery: []
        },
        description: {
          title:'',
          body: ''
        },
        showMap: true,
          showNav: false
      }),
      created() {
        this.fetchData();

        if(window.innerWidth <= 600) {
          this.showMap = false
        }

        window.addEventListener('resize', () => {
          window.innerWidth <= 600 ? this.showMap = false : this.showMap = true

        })
      },
      methods: {
        fetchData() {
          fetch('/pages/neighborhood')
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                this.images.firstImage = data[0].image;
                this.description.title = data[1].title;
                this.description.body = data[1].text;

                this.images.gallery = data[1].images;
                this.showNav = true
            });
        },
        handleScroll () {

              // Scroll fade
              let slides = document.getElementsByClassName("scrollFade");
              let slidesTitle = document.getElementsByClassName("scrollFadeText");
              let slidesBody = document.getElementsByClassName("scrollFadeBody");

              for (let i = 0; i < slidesTitle.length; i++) {
                  let elPos = slidesTitle[i].getBoundingClientRect().top
                  if(elPos < 60) {
                      slidesTitle[i].style.opacity = (elPos / 60)
                  } else {
                      slidesTitle[i].style.opacity = 1
                  }
              }

              for (let i = 0; i < slidesBody.length; i++) {
                  let elPos = slidesBody[i].getBoundingClientRect().top
                  if(elPos < 60) {
                      slidesBody[i].style.opacity = (elPos / 60)
                  } else {
                      slidesBody[i].style.opacity = 1
                  }
              }

            for (let i = 0; i < slides.length; i++) {
                let elPos = slides[i].getBoundingClientRect().top
                const elHeight = slides[i].offsetHeight
                const elPositionBottom = slides[i].getBoundingClientRect().bottom
                if(elPos < 0) {
                    slides[i].style.opacity = ( elPositionBottom / elHeight)
                } else {
                    slides[i].style.opacity = 1
                }
            }
          },
      },
      mounted () {
        document.getElementById('neighborhood').addEventListener('scroll', this.handleScroll);
      },
    }
</script>

<style scoped>

</style>
